import { render, staticRenderFns } from "./checkIcon.vue?vue&type=template&id=610afbfd&"
import script from "./checkIcon.vue?vue&type=script&lang=js&"
export * from "./checkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports